/**
 * Connection Types
 *
 * Shared types for the connections/networking feature — used by frontend and backend.
 */
export var ConnectionStatus;
(function (ConnectionStatus) {
    ConnectionStatus["PENDING"] = "PENDING";
    ConnectionStatus["ACCEPTED"] = "ACCEPTED";
})(ConnectionStatus || (ConnectionStatus = {}));
export var ConnectionRequestPolicy;
(function (ConnectionRequestPolicy) {
    ConnectionRequestPolicy["EVERYONE"] = "EVERYONE";
    ConnectionRequestPolicy["MUTUAL_CONNECTIONS"] = "MUTUAL_CONNECTIONS";
})(ConnectionRequestPolicy || (ConnectionRequestPolicy = {}));
